import React from "react";
import GenericListPage from "../../../Domain/Components/Functional/GenericListPage/GenericListPage";

function CampaignListPage(props) {
    return (
        <>
            <GenericListPage setLoggedIn={props.setLoggedIn}
                            detailsHref={"/campaign-operator-game-config/details"}
                            objectKeys={["id", "campaign.name",  "operator_game_config.game_config.name", "operator_game_config.internal_game_id", "operator_game_config.provider_game_id"]}
                            columnTitles={[
                                "ID", "Campaign Name","Game Name", "Internal Game ID", "Provider Game ID"
                            ]}
                            pageTitle={"Campaign Operator GameConfigs"}
                            readEndpoint={"campaign-operator-gameconfig/read"}
                            relations={["operator_game_config", "campaign", "operator_game_config.game_config"]}
                            />
        </>
    )
}

export default CampaignListPage;